import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { KeyboardViewer } from '@/components/microtonal/KeyboardViewer';
import { MICROTONAL_KIND } from '@/lib/microtonal/types';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
    case 'nprofile':
      return <div>Profile placeholder</div>;

    case 'note':
      return <div>Note placeholder</div>;

    case 'nevent':
      return <div>Event placeholder</div>;

    case 'naddr': {
      const { kind, pubkey, identifier: dTag } = decoded.data;
      // Render microtonal keyboard (kind 37357)
      if (kind === MICROTONAL_KIND) {
        return <KeyboardViewer pubkey={pubkey} dTag={dTag} kind={kind} />;
      }
      return <div>Addressable event (kind {kind}) — not supported.</div>;
    }

    default:
      return <NotFound />;
  }
} 